<template>
    <div>
        <div class="layout">
            <Sider :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}">
                <p class="co-study">商店管理</p>
                <Menu theme="dark" :active-name="selectedName[1]" width="auto" :open-names="[selectedName[0]]">
                    <Submenu name="商店">
                        <template slot="title">
                            <Icon type="md-cart" />
                            商店
                        </template>
						<MenuItem name="店铺管理" to="/shop/shop">店铺管理</MenuItem>
                        <MenuItem name="装扮排序" to="/shop/sort">装扮排序</MenuItem>
                        <MenuItem name="套装管理" to="/shop/suit">套装管理</MenuItem>
                        <MenuItem name="人设馆管理" to="/shop/role">人设馆管理</MenuItem>
                        <MenuItem name="形象审核" to="/shop/audit">形象审核</MenuItem>
                        <MenuItem name="道具管理" to="/shop/props">道具管理</MenuItem>
                    </Submenu>

                </Menu>
            </Sider>
            <Layout :style="{marginLeft: '200px'}">
                <Header :style="{position: 'fixed',width: 'calc(100vw - 200px)',padding: '0 16px',background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">
                    <div class="header-box">
                        <div class="header-info">
                            <Breadcrumb :style="{margin: '0',display:'inline'}">
                                <BreadcrumbItem v-for="(item,index) in selectedName" :key="index">{{item}}
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        <div class="header-menu">
                            <ul>
                                <li>
                                    <a @click="home">
                                      <Icon type="ios-home" />首页
                                    </a>
                                </li>
                                <li><a @click="logout">
                                    <Icon type="ios-log-out"/>
                                    退出</a></li>
                            </ul>
                        </div>
                    </div>
                </Header>
                <Content :style="{margin: '80px 16px 0', background: '#fff', minHeight: 'calc(100vh - 80px)'}">
                    <router-view/>
                </Content>
            </Layout>
        </div>
    </div>
</template>
<script>
    import apis from '../../http/api'
    import common from "../../utils/utils";

    export default {
        name: 'ReportCheckHome',
        data() {
            return {
                selectedName: [],
                openName: ['FAQ'],
                activeName: 'FAQ记录'
            }
        },
        created() {
            this.updateSelectName()
        },
        watch: {
            // $route(to, from){
            //     this.selectedName = [];
            //     this.$route.matched.forEach(record => {
            //         if(typeof(record.name) === 'string' && record.name.length > 0){
            //             this.selectedName.push(record.name)
            //         }
            //     });
            // },
            '$route': 'updateSelectName'
        },
        methods: {
            test() {

            },
            updateSelectName() {
                this.selectedName = [];
                this.$route.matched.forEach(record => {
                    if (typeof (record.name) === 'string' && record.name.length > 0) {
                        this.selectedName.push(record.name)
                    }
                });
            },
            logout() {
                common.delToken()
                this.$router.push('/login')
            },
            home() {
              this.$router.push('/pages')
            },
        },

    }
</script>
<style scoped>
    .layout {
        border: 0 solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .layout-header-bar {
        background: #fff;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
    }

    .co-study {
        text-align: center;
        padding: 15px 0;
        color: white;
        font-weight: bold;
        font-size: large;
    }

    .header-box {
        display: flex;
        justify-content: space-between;
    }

    .header-menu li {
        display: inline;
        margin-right: 10px;
    }

    .ivu-layout-header {
        z-index: 901;
    }
</style>
